import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material'
import { COLORS } from '../constants/colors'
import {
  MODAL_PAPER_STYLES,
  MODAL_TITLE_STYLES,
  MODAL_CONTENT_STYLES,
  MODAL_BUTTON_STYLES,
} from './shared/modalStyles'

interface ErrorModalProps {
  open: boolean
  title: string
  message: string
  onClose: () => void
}

export default function ErrorModal({
  open,
  title,
  message,
  onClose,
}: ErrorModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: MODAL_PAPER_STYLES }}
    >
      <DialogTitle sx={MODAL_TITLE_STYLES}>{title}</DialogTitle>
      <DialogContent>
        <Box sx={MODAL_CONTENT_STYLES}>{message}</Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            ...MODAL_BUTTON_STYLES,
            backgroundColor: COLORS.primary,
            color: COLORS.background,
            minWidth: '120px',
            '&:hover': {
              backgroundColor: COLORS.primary,
              opacity: 0.9,
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
